import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20lifestyle%20flat%20lay%20with%20cream%20linen%20shirt%20leather%20handbag%20and%20gold%20accessories%20on%20white%20marble%20surface%2C%20dried%20pampas%20grass%20and%20eucalyptus%2C%20soft%20morning%20sunlight%20casting%20gentle%20shadows%2C%20warm%20neutral%20palette%2C%20luxury%20editorial%20photography%2C%20minimalist%20composition%2C%20empty%20copy%20space%20center&width=1600&height=900&seq=hero-new-main-p1&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-6 text-center py-16 md:py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/90 backdrop-blur-sm border border-background-200/50 mb-6 md:mb-8">
          <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
          <span className="text-xs md:text-sm font-medium text-foreground-700">Zaktualizowano Czerwiec 2026</span>
        </div>

        <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5 md:mb-6 max-w-[800px] mx-auto drop-shadow-lg">
          USFansSpreadsheet – Wszystko, co musisz wiedzieć
        </h1>

        <p className="text-base md:text-lg text-background-50/90 max-w-[650px] mx-auto mb-8 md:mb-10 leading-relaxed font-light drop-shadow-md">
          Przewodniki, porównania, bezpieczeństwo i praktyczne rozwiązania związane z USFansSpreadsheet. 
          Kompletny zbiór wiedzy dla każdego użytkownika.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <Link
            to="/artykul/kompletny-przewodnik-usfansspreadsheet-2026"
            className="w-full sm:w-auto px-7 py-3.5 rounded-lg text-sm md:text-base font-semibold bg-background-50 text-foreground-950 hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer shadow-lg"
          >
            <i className="ri-book-open-line mr-2"></i>
            Zobacz pełny przewodnik
          </Link>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-7 py-3.5 rounded-lg text-sm md:text-base font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer shadow-lg"
          >
            <i className="ri-shopping-cart-line mr-2"></i>
            Poznaj rozwiązanie
          </a>
        </div>

        <div className="flex items-center justify-center gap-6 md:gap-8 mt-10 md:mt-12">
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-background-50 drop-shadow-md">10K+</p>
            <p className="text-xs md:text-sm text-background-50/80">Użytkowników</p>
          </div>
          <div className="w-px h-10 bg-background-50/25"></div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-background-50 drop-shadow-md">4.8</p>
            <p className="text-xs md:text-sm text-background-50/80">Ocena</p>
          </div>
          <div className="w-px h-10 bg-background-50/25"></div>
          <div className="text-center">
            <p className="font-heading text-2xl md:text-3xl font-bold text-background-50 drop-shadow-md">500+</p>
            <p className="text-xs md:text-sm text-background-50/80">Artykułów</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <a href="#co-to-jest" className="text-background-50/60 hover:text-background-50 transition-colors cursor-pointer" aria-label="Przewiń w dół">
          <i className="ri-arrow-down-line text-xl"></i>
        </a>
      </div>
    </section>
  );
}